import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { AllEarningsCallTranscriptsList } from "../types";
import axiosClient from "../utils/axiosClient";

export const useAllEarningsTranscriptsList = (
  pageTable: number,
  resultsPerPage: number = 20,
  searchTerm?: string,
  shouldFetchData?: boolean
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;

  const { isLoading, isError, data, refetch } = useQuery<
    any,
    AxiosError<any>,
    AllEarningsCallTranscriptsList
  >(
    ["transcripts", "list", pageTable, searchTerm],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        searchTerm,
      };

      if (!searchTerm) {
        delete query.searchTerm;
      }

      const data = await axiosClient.get<AllEarningsCallTranscriptsList>(
        `/earningsCall/getAll/transcriptsList?${qs.stringify(query)}`
      );

      // console.log("data----", data.data);
      return data.data;
    },
    {
      staleTime: Infinity,
      enabled: shouldFetchData, // Only enable the query when searchTerm is not empty
    }
  );

  return { isLoading, isError, data, refetch };
};